import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/App.scss';
import "./styles/Custom.scss"
import AllRoutes from './routes/AllRoutes';

function App() {
  return (
    <div className="App">
      <AllRoutes/>
    </div>
  );
}

export default App;
